import { AttrField, OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type SenderSource from '@/data/models/domain/SenderSource'
import type { UserNumbersResponse } from '@/services/domain/user/types'
import type { ModelRaw } from '@/types'

@OrmModel(modelNames.USER_NUMBERS)
export default class UserNumbers extends BaseModel implements UserNumbersResponse {
  @AttrField([])
  public dedicated: ModelRaw<SenderSource>[]

  @AttrField([])
  public shared: ModelRaw<SenderSource>[]

  @AttrField([])
  public userNumbers: ModelRaw<SenderSource>[]

  @AttrField([])
  public senderIds: ModelRaw<SenderSource>[]

  @AttrField([])
  public userCarrierTwilio: ModelRaw<SenderSource>[]

  @AttrField([])
  public userCarrierVonage: ModelRaw<SenderSource>[]

  @AttrField([])
  public userCarrierSinch: ModelRaw<SenderSource>[]

  @AttrField([])
  public userCarrierBandwidth: ModelRaw<SenderSource>[]

  @AttrField([])
  public userCarrierInfobip: ModelRaw<SenderSource>[]

  @AttrField([])
  public userCarrierMessageBird: ModelRaw<SenderSource>[]

  @AttrField([])
  public userCarrierAws: ModelRaw<SenderSource>[]

  @AttrField([])
  public userCarrierTelnyx: ModelRaw<SenderSource>[]

  @AttrField([])
  public userCarrierTwilioSenderId: ModelRaw<SenderSource>[]

  public get hasDedicatedNumbers() {
    return this.dedicated.length > 0
  }

  public get hasSenderIds() {
    return this.senderIds.length > 0
  }

  public get hasVerifiedUserOwnNumber() {
    return this.userNumbers.length > 0
  }
}
